import { render } from "./HtmlTemplate.vue?vue&type=template&id=20fa08f7"
import script from "./HtmlTemplate.vue?vue&type=script&lang=js"
export * from "./HtmlTemplate.vue?vue&type=script&lang=js"

import "./HtmlTemplate.vue?vue&type=style&index=0&id=20fa08f7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__